// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jr-z","response":"kr-z","error":"lr-z","disabled":"mr-z","buttons":"nr-z","feedbackQuestionSection":"or-z","yesNoWrapper":"pr-z"};